import { FC } from 'react';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import StaticField from 'further-ui/components/StaticField';
import { Column } from 'further-ui/components/Layout';
import { useLayoutContext } from 'contexts/LayoutContext';
import { BulletinUpdateFormValues } from '../schema';
import {
  bulletinRecipientTargetOptions,
  bulletinDeliveryMethodOptions,
  bulletinDeliveryMethodLabels,
} from '../constants';
import FormRadioButtons from './FormRadioButtons';

type Props = {
  control: Control<BulletinUpdateFormValues>;
  getValues: UseFormGetValues<BulletinUpdateFormValues>;
  readOnly: boolean;
};

const GeneralInformation: FC<Props> = ({ control, getValues, readOnly }) => {
  const { vehicle } = useLayoutContext();
  const deliveryMethod = getValues('deliveryMethod');

  return readOnly ? (
    <Column spacing="sm">
      <Typography variant="h5">General information</Typography>
      <Column spacing="lg">
        <StaticField label="Vehicle">{vehicle?.vehicleName}</StaticField>
        <StaticField label="Delivery method">
          {bulletinDeliveryMethodLabels[deliveryMethod]}
        </StaticField>
      </Column>
    </Column>
  ) : (
    <>
      <Column spacing="lg">
        <StaticField label="Vehicle">{vehicle?.vehicleName}</StaticField>
        <Divider />
        <Controller
          control={control}
          name="recipientTarget"
          render={({ field }) => (
            <FormRadioButtons
              label="Select recipients"
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              options={bulletinRecipientTargetOptions}
            />
          )}
        />
        <Divider />
        <Controller
          control={control}
          name="deliveryMethod"
          render={({ field }) => (
            <FormRadioButtons
              label="Delivery method"
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              options={bulletinDeliveryMethodOptions}
            />
          )}
        />
      </Column>
    </>
  );
};

export default GeneralInformation;
